import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import { withNamespaces } from 'react-i18next';

import { analytics } from 'core/analytics';
import { staticURL } from 'core/url';
import DocumentHead from 'legacyComponents/documentHead';
import Header from 'apps/components/header/header';

import { ContentIntro } from 'apps/components/contentIntro';
import { Plans } from 'apps/home/pricing/plans';
import { Features } from 'apps/home/pricing/features';

@withNamespaces()
@inject('routerStore')
@observer
export class PricingPage extends React.Component {
  componentDidMount() {
    analytics.sendEvent(
      'InitiateCheckout',
      { value: 5, currency: 'EUR' },
      { twitter: true, facebook: true },
    );
    analytics.linkedinPixel('1169113');
  }

  requestADemo = () => {
    if (!MAILERLITE_ID) {
      console.error('Mailerlite is not configured');
      return;
    }
    const ml_account = ml('accounts', MAILERLITE_ID, 'l8l9n0a9r1', 'load');
    const ml_webform_4098475 = ml_account(
      'webforms',
      '4098475',
      'g5n7l0',
      'load',
    );
    ml_webform_4098475('animation', 'fadeIn');
    ml_webform_4098475('show');
  };

  render() {
    return (
      <>
        <DocumentHead imagePath={staticURL('assets/wikifactory.jpg')} />
        <Header />
        <ContentIntro
          title={
            <>
              Pick the plan <br /> that&apos;s right for you.
            </>
          }
          variant='primary'
        />
        <Plans />
        <Features />
      </>
    );
  }
}

PricingPage.propTypes = {
  params: PropTypes.object,
  routerStore: PropTypes.object,
};
